import { createAsyncThunk } from "@reduxjs/toolkit";
import bandDashboardService from "../../../api/services/bandDashboard";

// Band Analytics
export const getBandAnalytics = createAsyncThunk(
  "bandDashboard/getBandAnalytics",
  async (bandId, { rejectWithValue }) => {
    try {
      const response = await bandDashboardService.getBandAnalytics(bandId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getBandProductAnalytics = createAsyncThunk(
  "bandDashboard/getBandProductAnalytics",
  async (bandId, { rejectWithValue }) => {
    try {
      const response = await bandDashboardService.getBandProductAnalytics(
        bandId
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Band Products
export const getBandProducts = createAsyncThunk(
  "bandDashboard/getBandProducts",
  async ({ bandId, ...params }, { rejectWithValue }) => {
    try {
      const response = await bandDashboardService.getBandProducts(
        bandId,
        params
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Band Orders
export const getBandOrders = createAsyncThunk(
  "bandDashboard/getBandOrders",
  async ({ bandId, ...params }, { rejectWithValue }) => {
    try {
      const response = await bandDashboardService.getBandOrders(bandId, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Band Monthly Revenues
export const getBandMonthlyRevenues = createAsyncThunk(
  "bandDashboard/getBandMonthlyRevenues",
  async (bandId, { rejectWithValue }) => {
    try {
      const response = await bandDashboardService.getBandMonthlyRevenues(
        bandId
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getMonthlyBandRevenuesByPeriod = createAsyncThunk(
  "revenue/get-monthly-band-revenues-by-period",
  async ({ bandId, startYear, startMonth, endYear, endMonth }) => {
    return await bandDashboardService.getMonthlyBandRevenuesByPeriod({
      bandId,
      startYear,
      startMonth,
      endYear,
      endMonth,
    });
  }
);
